<div id="fixedBasketErrorPage" class="ya-typography">
  <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
    <div class="title margin-down" [langkey]="messagePlaceholder"></div>
    <ng-container *ngIf="returnURL">
      <div class="ya-webshop-button-container">
        <a [href]="returnURL" target="_self">
          <button mat-flat-button>
            <span langkey="phGlobal_Return"></span>
          </button>
        </a>
      </div>
    </ng-container>
  </div>
</div>